import { useAppDispatch, useAppSelector } from "@/app/redux/hooks/reduxHooks"
import React, { useEffect, useState } from "react"
import Image from "next/image"
import { motion, AnimatePresence } from "framer-motion"
import { setPromoModal } from "@/app/redux/slices/slice.dashboard"

const PromotionModal = () => {
    const rank = useAppSelector((state) => state.dashboard.rank)
    const currentRankIcon = useAppSelector((state) => state.dashboard.currentRankIcon)
    const promoModal = useAppSelector((state) => state.dashboard.promoModal)
    const [open, setOpen] = useState<boolean>(false)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (promoModal) {
            setOpen(true)
            dispatch({ type: "dashboard/setPromoModal", payload: false })
        }
    }, [promoModal])

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    exit={{ opacity: 0, y: -500 }}
                    className="w-[100vw] h-[100vh] bg-[rgba(0,0,0,0.8)] fixed flex items-center justify-center top-0 left-0 z-20"
                >
                    <div>
                        <h2 className="text-[21px]">Congrats, you've been promoted to {rank}!</h2>
                        {currentRankIcon && (
                            <motion.div
                                initial={{ opacity: 0, y: -100, scale: 0.9, rotate: 180 }}
                                animate={{
                                    opacity: 1,
                                    y: 0,
                                    scale: 1,
                                    rotate: 0,
                                    transition: { delay: 1, duration: 1.5 },
                                }}
                            >
                                <Image
                                    src={currentRankIcon!}
                                    width="300"
                                    height="300"
                                    alt="Tier Promotion"
                                    className="block mx-auto my-5"
                                />
                            </motion.div>
                        )}
                        <button
                            className="text-black font-bold text-center block mx-auto bg-primary rounded px-2"
                            onClick={() => setOpen(false)}
                        >
                            Close
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default PromotionModal
